import { render, staticRenderFns } from "./ListPostPage.vue?vue&type=template&id=0299be1c"
import script from "./ListPostPage.vue?vue&type=script&lang=js"
export * from "./ListPostPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports